import script from "./ProductPricePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPricePanel.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPricePanel.vue?vue&type=style&index=0&id=5eacd484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eacd484"]])

export default __exports__